//
//
//
//
//
//
//
//
//
//
//
//

import { Container } from '@backmarket/design-system'

import CookiesSettings from '../CookiesSettings'

import translations from './CookiesModal.translations'

export default {
  components: {
    Container,
    CookiesSettings,
  },
  props: {
    zone: {
      type: String,
      default: '',
    },
  },
  computed: {
    translations: () => translations,
  },
}
